/**
 * [和德保险预充值]
 */

import React, { useState } from 'react';
import styles from './modal.module.scss';
import { Modal, InputNumber, message } from 'antd';
import { priceUppercase } from '@/util/money';
import * as apis from '@/apis/finance/hedeInsure';

const formatYuan = (val) => {
    const num = Number(val);
    if (val === undefined || val === null || val === '' || Number.isNaN(num)) {
        return '0.00';
    }
    return num.toFixed(2);
};

function HedeChargeModal(props) {
    const [amount, setAmount] = useState();
    const [confirmLoading, setConfirmLoading] = useState(false);

    const onClose = () => {
        props.onClose();
    };

    const onSubmit = () => {
        if (amount === undefined || amount === null || amount === '') {
            message.error('请输入充值金额！');
            return;
        }
        if (Number(amount) <= 0) {
            message.error('请输入充值金额！');
            return;
        }

        setConfirmLoading(true);
        apis.charge({ amount: Number(amount).toFixed(2) }).then((res) => {
            const payUrl = res.result && res.result.payUrl;
            if (!payUrl) {
                message.error('未获取到充值支付链接');
                return;
            }
            const opened = window.open(payUrl, '_blank', 'noopener,noreferrer');
            if (!opened) {
                Modal.info({
                    title: '请完成充值支付',
                    content: <a href={payUrl} target="_blank" rel="noreferrer">浏览器拦截了弹窗，点击此处打开支付页面</a>,
                });
            } else {
                message.success('请在打开的页面完成支付');
            }
            props.onOk();
        }).catch((err) => {
            message.error(err.message);
        }).finally(() => {
            setConfirmLoading(false);
        });
    };

    return (
        <Modal
            visible={true}
            centered
            title="和德保险预充值"
            width="700px"
            onOk={onSubmit}
            onCancel={onClose}
            confirmLoading={confirmLoading}
            okText="确定"
            cancelText="取消"
        >
            <div className={styles.formBox}>
                <div className={styles.formItem}>
                    <div className={styles.label}>充值账户：</div>
                    <div className={styles.val}>和德保险预充值账户</div>
                </div>
                <div className={styles.formItem}>
                    <div className={styles.label}>当前余额：</div>
                    <div className={styles.val}>{formatYuan(props.balance)} 元</div>
                </div>
                <div className={styles.formItem}>
                    <div className={styles.label}>充值金额：</div>
                    <div className={styles.val}>
                        <InputNumber
                            className={styles.txt}
                            placeholder="请输入充值金额"
                            min={0.01}
                            precision={2}
                            value={amount}
                            onChange={setAmount}
                        />
                        <p>金额大写：{priceUppercase(amount || '')}</p>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default HedeChargeModal;
